export default __webpack_public_path__ + "static/media/sl1-thumb.73d7bd69.png";